import React, { useState } from 'react'
import { IconButton, TableCell, TableRow } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import Delete from './Delete'
import { useUpdateMapTrans } from '../../../hooks/api/map-transactions'
import Form from './Form'
import moment from 'moment'

const Row = ({ data, refetch }) => {
  const [openDelete, setOpenDelete] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)

  return (
    <>
      <TableRow>
        <TableCell>{moment(data.transactionDate).format('DD MMMM YYYY')}</TableCell>
        <TableCell>{data.description}</TableCell>
        <TableCell>{data.type}</TableCell>
        <TableCell>{data.amount}</TableCell>
        <TableCell>
          <IconButton color='primary' onClick={() => setOpenEdit(true)} size='small'>
            <EditIcon />
          </IconButton>
          <IconButton color='error' onClick={() => setOpenDelete(true)} size='small'>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <Delete data={data} open={openDelete} setOpen={setOpenDelete} refetch={refetch} />
      <Form
        defaultValues={data}
        open={openEdit}
        setOpen={setOpenEdit}
        api={useUpdateMapTrans}
        refetch={refetch}
      />
    </>
  )
}

export default Row
